import {FULFILLED} from 'redux-promise-middleware';
import {AxiosResponse} from 'axios';
import {createReducer} from 'redux-act';

import {DEFAULT_COUNTRY} from 'constants/location';

import {fetchCountries, fetchRegions, FetchStatesActionMetaType} from 'actions/location/location';

import {LocationDefaultStateType} from './locationType';

export const defaultState: LocationDefaultStateType = {
    countries: [{value: DEFAULT_COUNTRY, label: 'United States'}],
    regions: {
        [DEFAULT_COUNTRY]: [],
    },
};

type CountriesBackendType = Array<{
    id: string;
    name: string;
    iso3_code: string;
    phone_code: string;
}>;

type RegionsBackendType = {id: string; name: string; code: string}[];

export const location = createReducer<LocationDefaultStateType>({}, defaultState)
    .on(
        `${fetchCountries}_${FULFILLED}`,
        (
            state: LocationDefaultStateType,
            {data}: AxiosResponse<CountriesBackendType>,
        ): LocationDefaultStateType => ({
            ...state,
            countries: data.map(({id, name}) => ({value: id, label: name})),
        }),
    )
    .on(
        `${fetchRegions}_${FULFILLED}`,
        (
            state: LocationDefaultStateType,
            {data}: AxiosResponse<RegionsBackendType>,
            meta?: FetchStatesActionMetaType,
        ): LocationDefaultStateType => ({
            ...state,
            regions: {
                ...state.regions,
                ...(meta
                    ? {
                          [meta.country]: data.length
                              ? data.map(({id, name, code}) => ({
                                    id: String(id),
                                    value: code,
                                    label: name,
                                }))
                              : [],
                      }
                    : {}),
            },
        }),
    );
